import SideMenu from './SideMenuContainer';

export default SideMenu;
